import type { Perk } from "@server/db/schema";

export type { Perk };

export function ProposalPerks({ perks }: { perks: Perk[] | null | undefined }) {
  const visible = (perks ?? []).filter(
    (p) =>
      p.enabled &&
      (p.title.trim().length > 0 ||
        p.description.trim().length > 0 ||
        p.amount.trim().length > 0)
  );
  if (visible.length === 0) return null;
  return (
    <div className="space-y-3">
      {visible.map((perk) => (
        <PerkBlock key={perk.id} perk={perk} />
      ))}
    </div>
  );
}

function PerkBlock({ perk }: { perk: Perk }) {
  return (
    <div className="flex items-start gap-3 rounded-2xl border border-dashed border-indigo-200 bg-indigo-50/60 px-4 py-4 sm:items-center sm:gap-5 sm:px-6 sm:py-5">
      <div
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg font-mono text-[11px] font-semibold text-white shadow-sm sm:h-11 sm:w-11 sm:text-xs"
        style={{
          background: "linear-gradient(135deg, #1E58FF 0%, #00FCCB 100%)",
        }}
        aria-hidden="true"
      >
        +€
      </div>
      <div className="min-w-0 flex-1">
        {perk.title && (
          <div className="break-words text-sm font-bold tracking-display text-foreground sm:text-[15px]">
            {perk.title}
          </div>
        )}
        {perk.description && (
          <div className="mt-1 max-w-2xl break-words text-xs leading-relaxed text-muted-foreground sm:text-[13px]">
            {perk.description}
          </div>
        )}
      </div>
      {perk.amount && (
        <div className="shrink-0 self-center font-display text-lg font-extrabold tabular-nums tracking-display text-foreground sm:text-2xl">
          {perk.amount}
        </div>
      )}
    </div>
  );
}
